module.exports = __webpack_public_path__ + "img/icon_note_white.82148554.svg";